//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { DEFAULT_TPL_FIELDS, METADATA_FILE_FORMAT, BUCKET_DIRECTORY_TYPES, METADATA_IMAGE_FORMAT, ROLES_LIST, PATTERNS_VALIDATION } from '@/js/constants';
import BiDatasetService from '@/apps/data-platform/services/visualization/bi_dataset_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import ProjectsService from '@/apps/data-platform/services/master_data/projects_service';
import UserProfileService from '@/apps/data-platform/services/user_profile_service';
import tasks from '@/js/tasks';
export default {
  name: 'DatasetTabTables',
  props: {
    item: {
      type: Object,
      default: function _default() {}
    },
    showButton: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    isChangeRequest: {
      type: String,
      default: ''
    }
  },
  computed: {
    filterDatasource: function filterDatasource() {
      var _this = this;
      var datasources = [];
      this.item.datasources.forEach(function (x) {
        datasources.push({
          value: x.datasourceId,
          text: _this.getDatasourceName(x, true)
        });
      });
      return datasources;
    }
  },
  data: function data() {
    return {
      DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
      METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
      BUCKET_DIRECTORY_TYPES: BUCKET_DIRECTORY_TYPES,
      METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
      ROLES_LIST: ROLES_LIST,
      PATTERNS_VALIDATION: PATTERNS_VALIDATION,
      kdatasource: '',
      new_table: {},
      projectListDict: [],
      isUrldatasource: false,
      inputUploadFile: null,
      currentFile: {},
      key_table: 1
    };
  },
  created: function created() {
    this.getProjects();
  },
  mounted: function mounted() {},
  methods: {
    filterTables: function filterTables(ds) {
      var tbls = [];
      tbls = this.item.tables.filter(function (x) {
        return x.datasource_id == ds.datasourceId;
      });
      return tbls;
    },
    getDatasourceName: function getDatasourceName(ds) {
      var para_lista = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var name = "";
      var detail = "";
      if (ds.connectionDetails && ds.connectionDetails.kind) {
        name = ds.connectionDetails.kind;
      } else {
        name = ds.datasourceType;
      }
      if (ds.connectionDetails && ds.connectionDetails.url) detail = this.getNameUrl(ds.connectionDetails.url);else if (ds.connectionDetails && ds.connectionDetails.database) detail = ds.connectionDetails.database;else if (ds.connectionDetails && ds.connectionDetails.path) detail = this.getNameFilePath(ds.connectionDetails.path);else if (ds.datasourceType == "Oracle") detail = this.getNameUrl(ds.connectionDetails.server);
      return name + (para_lista && detail ? " - " + detail : "");
    },
    getNameUrl: function getNameUrl(url) {
      if (!url) return "";
      var splitUrl = url.split("/");
      return splitUrl[splitUrl.length - 1] != '' ? splitUrl[splitUrl.length - 1] : splitUrl[splitUrl.length - 2];
    },
    getNameFilePath: function getNameFilePath(path) {
      if (!path) return "";
      var splitPath = path.split("\\");
      return splitPath[splitPath.length - 1] != '' ? splitPath[splitPath.length - 1] : splitPath[splitPath.length - 2];
    },
    copyLinkDatasource: function copyLinkDatasource(url) {
      navigator.clipboard.writeText(url);
      //this.$toast.info("Access link copied!")
    },
    onChangeDatasource: function onChangeDatasource() {
      var _this2 = this;
      this.new_table = {};
      this.inputUploadFile = null;
      var selected = this.item.datasources.filter(function (x) {
        return x.datasourceId == _this2.kdatasource && x.connectionDetails && x.connectionDetails.url;
      });
      if (selected.length > 0) this.isUrldatasource = true;else this.isUrldatasource = false;
    },
    isValidUploadFile: function isValidUploadFile() {
      var _this3 = this;
      var finds = this.item.tables.filter(function (x) {
        return x.datasource_id == _this3.kdatasource;
      });
      if (finds.length > 0) {
        tasks.toast.error("A file was attached already!");
        //this.$toast.warning("A file was attached already!")
        return false;
      }
      return true;
    },
    onFileChange: function onFileChange(event) {
      var _this4 = this;
      if (!this.isValidUploadFile()) return;
      var file = event.target.files[0];
      var fileReader = new FileReader();
      if (!file || file === undefined) {
        return;
      }
      if (file.size > 1024 * 1024) {
        e.preventDefault();
        tasks.toast.error("A file was attached already!");
        //this.$toast.warning('File too big (> 1MB)');
        return;
      }
      fileReader.onload = function (e) {
        var data = {
          content: e.target.result,
          filename: "".concat(_this4.item.luid, "/files/").concat(file.name),
          type: BUCKET_DIRECTORY_TYPES.DATASETS,
          domain_source: window.userInfo.domain
        };
        FilesService.uploadFile(data).then(function (res) {
          if (res['success']) {
            var _file = {
              datasource_id: _this4.kdatasource,
              domainTable: window.userInfo.domain,
              fileLink: res['data'] && res['data']['public_url'] || '',
              fileId: res['data'] && res['data']['file_id'] || '',
              fileName: res['data'] && res['data']['filename'] || '',
              type: "FILE"
            };
            _this4.item.tables.push(_file);
            _this4.inputUploadFile = null;
          } else {
            _this4.inputUploadFile = null;
            tasks.toast.error(res['message']);
            //this.$toast.warning(res['message'])
          }
        });
      };
      fileReader.readAsDataURL(file);
    },
    odAddTable: function odAddTable() {
      var _this5 = this;
      if (!this.valid()) {
        return;
      }
      var defaultParams = {
        values: {
          project_name: this.new_table.project_name,
          dataset_name: this.new_table.dataset_name,
          table_name: this.new_table.table_name,
          source: "bigquery"
        }
      };
      UserProfileService.validateTable(defaultParams).then(function (response) {
        if (response.code == 200 && response.success && response.data && response.data.id) {
          var new_data = {
            "datasource_id": _this5.kdatasource,
            project_name: _this5.new_table.project_name,
            dataset_name: _this5.new_table.dataset_name,
            table_name: _this5.new_table.table_name,
            type: response.data.type
          };
          _this5.item.tables.push(new_data);
          _this5.resetForm();
        } else {
          tasks.toast.error("The table or view does not exists or it is not in 'prod' enviroment yet.");
          //this.$toast.warning("The table or view does not exists or it is not in 'prod' enviroment yet.")
        }
      });
    },
    resetForm: function resetForm() {
      this.new_table = {};
      this.kdatasource = '';
    },
    valid: function valid() {
      var _this6 = this;
      if (!this.kdatasource) {
        tasks.toast.error("Select a datasource!");
        //this.$toast.warning("Select a datasource!")
        return false;
      }
      if (!this.new_table.project_name) {
        tasks.toast.error("Set the project name!");
        //this.$toast.warning("Set the project name!")
        return false;
      }
      if (!this.new_table.dataset_name) {
        tasks.toast.error("Set the dataset name!");
        //this.$toast.warning("Set the dataset name!")
        return false;
      }
      if (!this.new_table.table_name) {
        tasks.toast.error("Set the table name!");
        //this.$toast.warning("Set the table name!")
        return false;
      }
      var finds = this.item.tables.filter(function (x) {
        return x.project_name == _this6.new_table.project_name && x.dataset_name == _this6.new_table.dataset_name && x.table_name == _this6.new_table.table_name;
      });
      if (finds.length > 0) {
        tasks.toast.error("The table was selected already!");
        //this.$toast.warning("The table was selected already!")
        return false;
      }
      return true;
    },
    getProjects: function getProjects() {
      var _this7 = this;
      ProjectsService.getAllProjects().then(function (response) {
        if (response.code = 200 && response.success) {
          _this7.domainList = response.data.domains;
          _this7.projectListDict = [];
          response.data.projects[window.userInfo.domain].forEach(function (x) {
            _this7.projectListDict.push({
              "value": x,
              "text": x
            });
          });
        }
      }, function (err) {
        console.log(err);
      });
    },
    onSubmit: function onSubmit() {
      var tables_keys = [];
      this.item.tables.forEach(function (element) {
        tables_keys.push(element.project_name + "." + element.dataset_name + "." + element.table_name);
      });
      this.item.tables_keys = tables_keys;
      var dataset = {
        domain: window.userInfo.domain,
        dataset: this.item
      };
      BiDatasetService.datasetAddUpdate(dataset).then(function (res) {
        if (res.success && res.code === 200) {
          if (res.success) {
            tasks.toast.success('Dataset fields updated!');
            //this.$toast.success('Dataset fields updated!')
            //this.onCancel()
            //this.$emit('onSave', dataset.dataset)
          } else {
            tasks.toast.error(res.message);
            //this.$toast.warning(res.message)
            //this.onCancel()
          }
        }
      });
    },
    onClickLink: function onClickLink(file) {
      var _this8 = this;
      FilesService.readFile(file.fileLink).then(function (response) {
        _this8.isLoading = false;
        if (response.success) {
          _this8.image = response.data.base64;
          _this8.dataImage = response.data;
          _this8.filename = response.data.name.split('/').pop();
          _this8.contentType = response.data.contentType;
          _this8.currentFile = {
            fileLink: response.data.base64,
            fileName: response.data.name.split('/').pop(),
            contentType: response.data.contentType
          };
          _this8.$bvModal.show('preview-file-ds');
        } else {
          _this8.currentFile = {
            fileLink: null,
            fileName: null,
            contentType: null
          };
          tasks.toast.error(response.message);
          //alert(response.message)
        }
      });
    },
    onCancel: function onCancel() {
      this.$emit('onCancel', null);
    },
    deleteItem: function deleteItem(table) {
      var index = this.item.tables.indexOf(table);
      if (index != -1) {
        this.item.tables.splice(index, 1);
      }
      this.key_table += 1;
    },
    onShowTable: function onShowTable(item) {
      this.$emit('onShowTable', item);
    }
  }
};